/** Props do componente ProgressBar */
export interface ProgressBarProps {
  /** Percentual de progresso (0–100) */
  readonly progressPercentage: number;
  /** Exibe o rótulo de percentual ao lado da barra */
  readonly shouldShowPercentage?: boolean;
}

/**
 * Barra de progresso linear com exibição opcional de percentual.
 *
 * @example
 * ```tsx
 * <ProgressBar shouldShowPercentage progressPercentage={72} />
 * ```
 */
export function ProgressBar({
  progressPercentage,
  shouldShowPercentage = false,
}: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, progressPercentage));

  return (
    <div className="flex items-center gap-nano">
      <div className="h-[4px] w-full overflow-hidden rounded-pill bg-ctx-layout-border">
        <div
          className="h-full rounded-pill bg-ctx-interactive-primary transition-[width] duration-300"
          style={{ width: `${clamped}%` }}
          role="progressbar"
          aria-valuenow={clamped}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
      {shouldShowPercentage && (
        <span className="ts-caption-xxxs shrink-0 text-ctx-content-base">{clamped}%</span>
      )}
    </div>
  );
}
